import { render, staticRenderFns } from "./batch-process-alarm-modal.vue?vue&type=template&id=55ab9c0c"
import script from "./batch-process-alarm-modal.vue?vue&type=script&lang=js"
export * from "./batch-process-alarm-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports